const HOURS_LABEL = 'h';
const MINUTES_LABEL = 'm';
const SECONDS_LABEL = 's';

export const formatTime = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secondsRemaining = Math.floor(seconds % 60);

  const formattedHours = `${hours} ${HOURS_LABEL}`;
  const formattedMinutes = `${minutes} ${MINUTES_LABEL}`;
  const formattedSeconds = `${secondsRemaining} ${SECONDS_LABEL}`;

  if (hours === 0 && minutes === 0 && secondsRemaining === 0) {
    return `0 ${SECONDS_LABEL}`;
  }

  if (hours === 0 && minutes === 0) {
    return formattedSeconds;
  }

  if (hours === 0) {
    return `${formattedMinutes} ${formattedSeconds}`;
  }

  return `${formattedHours} ${formattedMinutes} ${formattedSeconds}`;
};
